import React, { useState, useEffect, useRef } from 'react';
import ContextMappingDocSelector from './ContextMappingDocSelector';
import { StatusBadgeXSm } from '../../utils/StatusBadge';

const ToggleMenu = ({
    isLoading = false,
    templateData,
    setTemplateData,
    fabricId,
    templateId,
    handleRefresh,
    onUploadCommentedReport,
    canImportAgentContext = false,
    canUploadCommentedReport = false,
    hasPendingChanges = false
}) => {
    const menuToggleRef = useRef(null);
    const [isMenuToggleOpen, setIsMenuToggleOpen] = useState(false);

    const importContextSelectorRef = useRef(null);
    const [isContextMappingDocSelectorOpen, setIsContextMappingDocSelectorOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuToggleRef.current && !menuToggleRef.current.contains(event.target)) {
                setIsMenuToggleOpen(false);
            }
        };
        if (isMenuToggleOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isMenuToggleOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (importContextSelectorRef.current && !importContextSelectorRef.current.contains(event.target)) {
                setIsContextMappingDocSelectorOpen(false);
            }
        };
        if (isContextMappingDocSelectorOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isContextMappingDocSelectorOpen]);

    useEffect(() => {
        if (!isMenuToggleOpen && isContextMappingDocSelectorOpen) {
            setIsContextMappingDocSelectorOpen(false);
        }
    }, [isMenuToggleOpen, isContextMappingDocSelectorOpen]);

    const canShowImportAgentContext =
        canImportAgentContext && !!templateData && !!setTemplateData && !!handleRefresh;

    if (!canShowImportAgentContext && !canUploadCommentedReport) {
        return null;
    }

    const handleUploadCommentedReportClick = () => {
        if (onUploadCommentedReport) {
            onUploadCommentedReport();
        }
        setIsMenuToggleOpen(false);
    };

    return (
        <div ref={menuToggleRef} className="position-relative d-inline-block ms-2">
            <button
                type="button"
                className="ev-btn-text-only-fill ev-btn-xlarge avatar-tooltip p-0"
                onClick={() => setIsMenuToggleOpen((prev) => !prev)}
                data-tooltip={isMenuToggleOpen ? "Close" : "More Options"}
            >
                <i className="bi bi-list"></i>
            </button>

            {isMenuToggleOpen && (
                <div className="genbi-toggle-menu-dropdown">
                    <div className="genbi-toggle-menu-header">
                        <p className="ev-reg-p-dark mb-0">More Actions</p>

                        <button
                            type="button"
                            className="ev-btn-light-fill ev-btn-small"
                            onClick={() => {
                                setIsMenuToggleOpen(false);
                                setIsContextMappingDocSelectorOpen(false);
                            }}
                        >
                            <i className="bi bi-x-lg"></i>
                        </button>
                    </div>
                    <div className="h-auto pb-1">
                        {canShowImportAgentContext && (
                            <div className="ev-padding-small">
                                <div ref={importContextSelectorRef} className="position-relative">
                                    <button
                                        type="button"
                                        className={`ev-btn-menu-action avatar-tooltip ${isContextMappingDocSelectorOpen ? 'active' : ''}`}
                                        disabled={isLoading || templateData.running_agents > 0 || templateData.context_mapping_status === 'RUNNING'}
                                        onClick={() => setIsContextMappingDocSelectorOpen((prev) => !prev)}
                                        data-tooltip={
                                            templateData.context_mapping_status === 'RUNNING'
                                                ? "Agent context mapping is already in progress"
                                                : templateData.running_agents > 0
                                                    ? "Wait for agents to complete before mapping agent context"
                                                    : "Import document to map the agent context"
                                        }
                                    >
                                        <span className="d-flex align-items-center">
                                            <span className="ev-bold-reg">Import Agent Context</span>
                                        </span>

                                        <span className="ms-2">
                                            <StatusBadgeXSm status={templateData.context_mapping_status} />
                                        </span>
                                    </button>

                                    {isContextMappingDocSelectorOpen && (
                                        <div className="position-absolute z-1000 min-w-450 mt-1 end-0">
                                            <ContextMappingDocSelector
                                                fabricId={fabricId}
                                                templateId={templateId}
                                                hasPendingChanges={hasPendingChanges}
                                                onClose={() => setIsContextMappingDocSelectorOpen(false)}
                                                onMappingStarted={() => {
                                                    setTemplateData((prev) => ({
                                                        ...prev,
                                                        context_mapping_status: 'RUNNING'
                                                    }));
                                                    setIsContextMappingDocSelectorOpen(false);
                                                    setIsMenuToggleOpen(false);
                                                    handleRefresh();
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Upload Commented Report Option */}
                        {canUploadCommentedReport && (
                        <div className="ev-padding-small">
                            <button
                                type="button"
                                className="ev-btn-menu-action avatar-tooltip"
                                disabled={isLoading || templateData.running_agents > 0}
                                onClick={handleUploadCommentedReportClick}
                                data-tooltip={
                                    templateData.running_agents > 0
                                        ? "Wait for agents to complete before uploading commented report"
                                        : "Upload a Word document with comments to extract feedback"
                                }
                            >
                                <span className="d-flex align-items-center">
                                    <span className="ev-bold-reg">Upload Commented Report</span>
                                    <button
                                        type="button"
                                        className="ev-btn-blue-fill-round ms-2 ev-bold-reg ev-btn-small avatar-tooltip text-nowrap"

                                    >
                                        <i className="bi bi-file-earmark-arrow-up-fill"></i>
                                    </button>
                                </span>
                            </button>
                        </div>
                        )}

                    </div>
                </div>
            )}

        </div>
    );
};

export default ToggleMenu;